import './SolucionesEducativas.css';
import Effetoscroll from "../effectoscroll/effectoscroll";
import "../ServiceInicio/ServiceInicio.css";
import Footer from "../Footer/Footer.js"

// Importá las imágenes (ajustá las rutas según tu estructura)
import logoPetit from "../Assets/Img/descarga-removebg-preview.png";
import logoHorizonte from "../Assets/Img/isef-removebg-preview.png"; 
// import logoTecnica from "../Assets/Img/tecnica.png";     // O el nombre real

function SolucionesEducativas() {
  const instituciones = [
    { nombre: "Instituto Petit de Meurville", logo: logoPetit },
    { nombre: "Instituto Superior de Educación Fisica", logo: logoHorizonte },
    // { nombre: "Escuela Técnica Digital", logo: logoTecnica },
    // Podés agregar más instituciones con sus logos importados
  ];

  return (
    <>
    <div className='soluciones-contenedor'>
      <div className="soluciones-inner">

        {/* Beneficios (¿Por qué elegir Tresatec?) */}
        <div className="service-benefits">
          <h3 className="service-title">¿Por qué elegir Tresatec?</h3>
          {/* acá podés agregar los beneficios si querés */}
        </div>

        <Effetoscroll />

        {/* SOLO LOGOS - INSTITUCIONES QUE CONFÍAN */}
        <div className="instituciones-logos-section">
          <div className="instituciones-header-simple">
            <span className="instituciones-badge">Confían en nosotros</span>
            <h3>Instituciones que ya usan Tresaedu</h3>
          </div>

          <div className="logos-grid">
            {instituciones.map((inst, idx) => (
              <div key={idx} className="logo-card">
                <div className="logo-wrapper">
                  <img src={inst.logo} alt={inst.nombre} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA final */}
        <div className="service-cta">
          <h3>¿Listo para modernizar tu institución?</h3>
          <p>Solicitá una demostración personalizada sin compromiso.</p>
          <button className="service-btn-primary"> <a href="https://wa.me/message/ORWIOZ4UP74NM" target="_blank" rel="noopener noreferrer"></a>Solicitar demo</button>
        </div>

      </div>
    </div>
    <Footer/>
    </>
  );
}

export default SolucionesEducativas;